import React from 'react';
import { X } from 'lucide-react';

interface CloseButtonProps {
  onClick: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="absolute top-4 right-4 z-10 p-3 bg-black/40 backdrop-blur-sm rounded-full hover:bg-black/60 transition-all duration-200 hover:scale-110 group"
      aria-label="Close video player"
    >
      <X className="w-6 h-6 text-white/80 group-hover:text-white transition-colors duration-200" />
    </button>
  );
};

export default CloseButton;